"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperInner = exports.BaseRelatedArticlesImageWrapper = exports.BaseRelatedArticlesCard = exports.BaseRelatedArticleLinkWrapper = exports.BaseRelatedArticleImageInner = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _hoverEffects = require("../../../../helpers/styles/hover-effects");
var _theme = _interopRequireDefault(require("../../../../themes/Base/theme"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BaseRelatedArticleLinkWrapper = _styledComponents.default.a.withConfig({
  displayName: "styles__BaseRelatedArticleLinkWrapper",
  componentId: "sc-19kuvdd-0"
})(["text-decoration:none;color:inherit;&:hover{text-decoration:none;}"]);
exports.BaseRelatedArticleLinkWrapper = BaseRelatedArticleLinkWrapper;
var BaseRelatedArticlesCard = _styledComponents.default.li.withConfig({
  displayName: "styles__BaseRelatedArticlesCard",
  componentId: "sc-19kuvdd-1"
})(["margin:8px;max-width:400px;"]);
exports.BaseRelatedArticlesCard = BaseRelatedArticlesCard;
var BaseRelatedArticlesImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__BaseRelatedArticlesImageWrapper",
  componentId: "sc-19kuvdd-2"
})(["max-width:100%;position:relative;width:100%;height:100%;@media ", "{width:400px;height:225px;}"], function (props) {
  var _props$theme$device_m, _props$theme, _props$theme$device_m2;
  return (_props$theme$device_m = (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$device_m2 = _props$theme.device_media) === null || _props$theme$device_m2 === void 0 ? void 0 : _props$theme$device_m2.mobileXL) !== null && _props$theme$device_m !== void 0 ? _props$theme$device_m : _theme.default.device_media.mobileXL;
});
exports.BaseRelatedArticlesImageWrapper = BaseRelatedArticlesImageWrapper;
var BaseRelatedArticleImageInner = _styledComponents.default.div.withConfig({
  displayName: "styles__BaseRelatedArticleImageInner",
  componentId: "sc-19kuvdd-3"
})(["", " position:absolute;top:0;left:0;width:100%;height:100%;> img{display:block;width:100%;height:100%;}"], (0, _hoverEffects.scaleContainingImageDown)(BaseRelatedArticleLinkWrapper));
exports.BaseRelatedArticleImageInner = BaseRelatedArticleImageInner;
var WrapperInner = _styledComponents.default.article.withConfig({
  displayName: "styles__WrapperInner",
  componentId: "sc-19kuvdd-4"
})(["display:flex;flex-direction:column;"]);
exports.WrapperInner = WrapperInner;